import {FC, useEffect, useState} from 'react'
import {BaseModal} from '../../BaseModal/BaseModal'
import {Input} from '../../../Input/Input'
import {Button} from '../../../Button/Button'
import styles from './editVariacao.module.css'

type Props = {
  onCloseAction: () => void
  title: string
  item: {
    id: string
    nome: string
    estoque: string
    precoVenda: string
    precoCusto: string
    precoPromocional: string
    status: boolean
    img: string | File
    height: number
    width: number
    deep: number
    weight: number
    sku: string
    referenceCode: string
    gtin: string
    mpn: string
    ncm: string
    minumunStock: string
    productAvailability: string
    productOutOfStock: string
    modality: string
  }
  onSave?: (item: any) => void
}

const EditVariacao: FC<Props> = ({onCloseAction, title, item, onSave}) => {
  const [editItem, setEditItem] = useState({...item})
  const [imgPreview, setImgPreview] = useState<string | null>(
    typeof item.img === 'string'
      ? item.img
      : item.img instanceof File
      ? URL.createObjectURL(item.img)
      : null
  )

  const handleChange = (field: string, value: any) => {
    setEditItem((prev) => ({...prev, [field]: value}))
    if (field === 'img') {
      if (value && value instanceof File) {
        setImgPreview(URL.createObjectURL(value))
      } else if (typeof value === 'string') {
        setImgPreview(value)
      }
    }
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0]
    if (file) {
      handleChange('img', file)
    }
  }

  return (
    <BaseModal onCloseAction={onCloseAction} title={title}>
      <div className='mb-4'>
        <label className='form-label fw-normal'>Imagem da Variação</label>
        <div className={styles.imgPreviewContainer}>
          <input
            type='file'
            accept='.jpg, .jpeg, .png, .gif'
            className={`${styles.inputEdit} custom-file-input`}
            onChange={handleFileChange}
          />
          {imgPreview ? (
            <img src={imgPreview} alt='Preview' className={styles.imgPreview} />
          ) : (
            <i className='bi bi-image fs-1 text-gray-400'></i>
          )}
        </div>
      </div>
      <div className={`pb-9 ${styles.infoContainer}`}>
        <Input
          label='Estoque'
          value={editItem.estoque}
          inputAttr={{type: 'default'}}
          placeholder='Digite o estoque'
          change={(v: any) => handleChange('estoque', v)}
        />
        <Input
          inputAttr={{
            type: 'money',
          }}
          currency='BRL'
          locale='pt-BR'
          label='Preço de Venda'
          value={editItem.precoVenda}
          placeholder='Digite o preço de venda'
          change={(v: any) => handleChange('precoVenda', v)}
        />
        <Input
          inputAttr={{
            type: 'money',
          }}
          currency='BRL'
          locale='pt-BR'
          label='Preço de Custo'
          value={editItem.precoCusto}
          placeholder='Digite o preço de custo'
          change={(v: any) => handleChange('precoCusto', v)}
        />
        <Input
          inputAttr={{
            type: 'money',
          }}
          currency='BRL'
          locale='pt-BR'
          label='Preço Promocional'
          value={editItem.precoPromocional}
          placeholder='Digite o preço promocional'
          change={(v: any) => handleChange('precoPromocional', v)}
        />
        <Input
          label='Status'
          value={editItem.status}
          checked={editItem.status}
          inputAttr={{type: 'checkbox'}}
          checkSwift={true}
          change={(v: boolean) => handleChange('status', v)}
        />
        <Input
          label='Altura'
          value={editItem.height}
          inputAttr={{type: 'number'}}
          placeholder='Digite a altura'
          change={(v: any) => handleChange('height', v)}
        />
        <Input
          label='Largura'
          value={editItem.width}
          inputAttr={{type: 'number'}}
          placeholder='Digite a largura'
          change={(v: any) => handleChange('width', v)}
        />
        <Input
          label='Profundidade'
          value={editItem.deep}
          inputAttr={{type: 'number'}}
          placeholder='Digite a profundidade'
          change={(v: any) => handleChange('deep', v)}
        />
        <Input
          label='Peso'
          value={editItem.weight}
          inputAttr={{type: 'number'}}
          placeholder='Digite o peso'
          change={(v: any) => handleChange('weight', v)}
        />
        <Input
          label='SKU'
          value={editItem.sku}
          inputAttr={{type: 'default'}}
          placeholder='Digite o SKU'
          change={(v: any) => handleChange('sku', v)}
        />
        <Input
          label='Código de Referência'
          value={editItem.referenceCode}
          inputAttr={{type: 'default'}}
          placeholder='Digite o código de referência'
          change={(v: any) => handleChange('referenceCode', v)}
        />
        <Input
          label='GTIN'
          value={editItem.gtin}
          inputAttr={{type: 'default'}}
          placeholder='Digite o GTIN'
          change={(v: any) => handleChange('gtin', v)}
        />
        <Input
          label='MPN'
          value={editItem.mpn}
          inputAttr={{type: 'default'}}
          placeholder='Digite o MPN'
          change={(v: any) => handleChange('mpn', v)}
        />
        <Input
          label='NCM'
          value={editItem.ncm}
          inputAttr={{type: 'default'}}
          placeholder='Digite o NCM'
          change={(v: any) => handleChange('ncm', v)}
        />
        <Input
          label='Estoque Mínimo'
          value={editItem.minumunStock}
          inputAttr={{type: 'number'}}
          placeholder='Digite o estoque mínimo'
          change={(v: any) => handleChange('minumunStock', v)}
        />
        <Input
          inputAttr={{
            type: 'select',
          }}
          value={editItem.productAvailability}
          change={(v: any) => handleChange('productAvailability', v)}
          label='Disponibilidade do Produto'
          options={[
            {select: 'Disponibilidade imediata', value: 0},
            {select: 'Disponibilidade para 1 dia útil', value: 1},
            {select: 'Disponibilidade para 2 dias úteis', value: 2},
            {select: 'Disponibilidade para 3 dias úteis', value: 3},
            {select: 'Disponibilidade para 4 dias úteis', value: 4},
            {select: 'Disponibilidade para 5 dias úteis', value: 5},
            {select: 'Disponibilidade para 6 dias úteis', value: 6},
            {select: 'Disponibilidade para 7 dias úteis', value: 7},
            {select: 'Disponibilidade para 8 dias úteis', value: 8},
            {select: 'Disponibilidade para 9 dias úteis', value: 9},
            {select: 'Disponibilidade para 10 dias úteis', value: 10},
            {select: 'Disponibilidade para 15 dias úteis', value: 15},
            {select: 'Disponibilidade para 20 dias úteis', value: 20},
            {select: 'Disponibilidade para 25 dias úteis', value: 25},
            {select: 'Disponibilidade para 30 dias úteis', value: 30},
            {select: 'Disponibilidade para 45 dias úteis', value: 45},
            {select: 'Disponibilidade para 60 dias úteis', value: 60},
            {select: 'Disponibilidade para 90 dias úteis', value: 90},
          ]}
        />
        <Input
          inputAttr={{
            type: 'select',
          }}
          value={editItem.productOutOfStock}
          change={(v: any) => handleChange('productOutOfStock', v)}
          label='Produto Fora de Estoque'
          options={[
            {select: 'Continuar vendendo normalmente', value: 0},
            {select: 'Tornar o produto indisponível', value: -1},
            {select: 'Mudar a disponibilidade para 1 dia útil', value: 1},
            {select: 'Mudar a disponibilidade para 2 dias úteis', value: 2},
            {select: 'Mudar a disponibilidade para 3 dias úteis', value: 3},
            {select: 'Mudar a disponibilidade para 4 dias úteis', value: 4},
            {select: 'Mudar a disponibilidade para 5 dias úteis', value: 5},
            {select: 'Mudar a disponibilidade para 6 dias úteis', value: 6},
            {select: 'Mudar a disponibilidade para 7 dias úteis', value: 7},
            {select: 'Mudar a disponibilidade para 8 dias úteis', value: 8},
            {select: 'Mudar a disponibilidade para 9 dias úteis', value: 9},
            {select: 'Mudar a disponibilidade para 10 dias úteis', value: 10},
            {select: 'Mudar a disponibilidade para 15 dias úteis', value: 15},
            {select: 'Mudar a disponibilidade para 20 dias úteis', value: 20},
            {select: 'Mudar a disponibilidade para 25 dias úteis', value: 25},
            {select: 'Mudar a disponibilidade para 30 dias úteis', value: 30},
            {select: 'Mudar a disponibilidade para 45 dias úteis', value: 45},
            {select: 'Mudar a disponibilidade para 60 dias úteis', value: 60},
            {select: 'Mudar a disponibilidade para 90 dias úteis', value: 90},
          ]}
        />
        <Input
          label='Modalidade'
          value={editItem.modality}
          inputAttr={{type: 'default'}}
          placeholder='Digite a modalidade'
          change={(v: any) => handleChange('modality', v)}
          disabled
        />
      </div>
      <div className={`d-flex justify-content-end pt-6 ${styles.footer}`}>
        <Button
          text='Salvar'
          color='primary'
          size='small'
          horizontalPadding={5}
          btnAttr={{type: 'button'}}
          click={() => {
            if (onSave) onSave(editItem)
            onCloseAction()
          }}
          btnClass='fw-bolder'
        />
      </div>
    </BaseModal>
  )
}

export {EditVariacao}
